export default __webpack_public_path__ + "static/media/video.669fa5ce.jpeg";